import config from "../config/config";
import { apiURI } from "./apiURI";

export function getServerUri(servicePath) {
  const currentURI = new URL(window.location);
  let uri = apiURI + "/" + servicePath + "/";
  return uri;
}

// Build the WebSocket URL for the agent socket, carrying the accessToken as a
// query param (browsers can't set headers on the WebSocket upgrade request).
//
// When the API host matches the dashboard host (staging/test), derive wss/ws from
// the page protocol so an https page never tries ws:// (mixed-content block).
// When the API is on a separate host (production api.playin.com.tr), derive from
// the apiURI scheme instead.
export function getSocketUri() {
  const accessToken = localStorage.getItem("session.accessToken") || "";

  let wsOrigin;
  try {
    const api = new URL(apiURI);
    const page = window.location;
    const sameHost = api.hostname === page.hostname;

    if (sameHost) {
      const wsProtocol = page.protocol === "https:" ? "wss:" : "ws:";
      wsOrigin = `${wsProtocol}//${api.host}`;
    } else {
      const wsProtocol = api.protocol === "https:" ? "wss:" : "ws:";
      wsOrigin = `${wsProtocol}//${api.host}`;
    }
  } catch (_err) {
    const fallback = apiURI.replace(/^https/i, "wss").replace(/^http/i, "ws");
    wsOrigin = fallback.replace(/\/+$/, "");
  }

  return `${wsOrigin}/socket/ws?accessToken=${encodeURIComponent(accessToken)}`;
}
